export default __webpack_public_path__ + "locales/de/Settings.json?hash=fb871deb5e74e1c10a7d76b4556863c2";